import React from 'react'

import { Element } from '../Element'
import { ExternalLink } from '../Link'
import { Stack } from '../Stack'
import { LinkText, Text } from '../Text'
import { useBreakpoint } from '../useBreakpoint'

import { Icon } from '../Icon'

export const Footer = () => {
  const breakpoint = useBreakpoint()

  return (
    <Element component={breakpoint === 0 ? 'FooterMobile' : 'FooterDesktop'}>
      <Stack direction='horizontal' justifyContent='space-between'>
        <Stack>
          <Text size={4} variant='footerHero'>
            Guild
          </Text>

          <Stack direction='horizontal' alignItems='center' gap={1}>
            <ExternalLink to='https://www.youtube.com/@guild_host'>
              <Icon name='youtube' variant='footerIcon' size={4} />
            </ExternalLink>
            <ExternalLink to='https://twitter.com/guild__host'>
              <Icon name='twitter' variant='footerIcon' size={3.5} />
            </ExternalLink>
            <ExternalLink to='https://www.linkedin.com/company/guild-host'>
              <Icon name='linkedin' variant='footerIcon' size={4} />
            </ExternalLink>
          </Stack>
        </Stack>
        <Stack>
          <Text size={4} variant='footer'>
            Got feedback or questions?
          </Text>
          <Text size={4} variant='footer'>
            Contact Us:{' '}
            <span className='notranslate'>
              <ExternalLink to='mailto:hi@guild.host'>
                <LinkText size={4} variant='noUnderline'>
                  hi@guild.host
                </LinkText>
              </ExternalLink>
            </span>
          </Text>
        </Stack>
      </Stack>
    </Element>
  )
}
